import { gql } from '@apollo/client';
import { forPaginated } from './common/paginated.graphql';
import {
  CompanyConnection,
  CreateCompanyConnectionInput,
  DeleteCompanyConnectionInput,
  UpdateCompanyConnectionInput,
} from '../types/companyConnection/companyConnection';

const companyConnection = gql`
  fragment CompanyConnection on CompanyConnection {
    id
    version
    createdAt
    createdBy
    updatedAt
    updatedBy
    companyId
    parentId
    state
    types
  }
`;

const get = gql`
  query CompanyConnections($page: Float) {
    companyConnections(page: $page) {
      data {
        ...CompanyConnection
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${companyConnection}
`;

export interface GetCompanyConnectionVariables {
  page?: number;
}

export interface GetCompanyConnectionResponse {
  companyConnections: PaginatedCompanyConnection;
}

class PaginatedCompanyConnection extends forPaginated<CompanyConnection>() {}

const create = gql`
  mutation CreateCompanyConnection($companyConnections: [CreateCompanyConnectionInput!]!) {
    createCompanyConnection(companyConnections: $companyConnections) {
      ...CompanyConnection
    }
  }
  ${companyConnection}
`;

export interface CreateCompanyConnectionVariables {
  companyConnections: CreateCompanyConnectionInput[];
}

export interface CreateCompanyConnectionResponse {
  createCompanyConnection: CompanyConnection[];
}

const update = gql`
  mutation UpdateCompanyConnection($companyConnections: [UpdateCompanyConnectionInput!]!) {
    updateCompanyConnection(companyConnections: $companyConnections) {
      ...CompanyConnection
    }
  }
  ${companyConnection}
`;

export interface UpdateCompanyConnectionVariables {
  companyConnections: UpdateCompanyConnectionInput[];
}

export interface UpdateCompanyConnectionResponse {
  updateCompanyConnection: CompanyConnection[];
}

const remove = gql`
  mutation DeleteCompanyConnection($companyConnections: [DeleteCompanyConnectionInput!]!) {
    deleteCompanyConnection(companyConnections: $companyConnections) {
      ...CompanyConnection
    }
  }
  ${companyConnection}
`;

export interface DeleteCompanyConnectionVariables {
  companyConnections: DeleteCompanyConnectionInput[];
}

export interface DeleteCompanyConnectionResponse {
  deleteCompanyConnection: CompanyConnection[];
}

const accept = gql`
  mutation AcceptCompanyConnection($id: String!) {
    acceptCompanyConnection(id: $id) {
      ...CompanyConnection
    }
  }
  ${companyConnection}
`;

export interface AcceptCompanyConnectionVariables {
  id: string;
}

export interface AcceptCompanyConnectionResponse {
  acceptCompanyConnection: CompanyConnection[];
}

const decline = gql`
  mutation DeclineCompanyConnection($id: String!) {
    declineCompanyConnection(id: $id) {
      ...CompanyConnection
    }
  }
  ${companyConnection}
`;

export interface DeclineCompanyConnectionVariables {
  id: string;
}

export interface DeclineCompanyConnectionResponse {
  declineCompanyConnection: CompanyConnection[];
}

const createAsPartner = gql`
  mutation CreateCompanyAsPartner($name: String!) {
    createCompanyAsPartner(name: $name) {
      ...CompanyConnection
    }
  }
  ${companyConnection}
`;

export interface CreateCompanyAsPartnerVariables {
  name: string;
}

export interface CreateCompanyAsPartnerResponse {
  createCompanyAsPartner: CompanyConnection;
}

export const CompanyConnectionQueries = {
  get,
};

export const CompanyConnectionMutations = {
  create,
  update,
  remove,
  accept,
  decline,
  createAsPartner,
};

export const CompanyConnectionFragments = {
  companyConnection,
};
